import {
    IFiltroRenegociacaoAnalise,
    IRenegociacaoAnalise,
    IRenegociacoesAnalise,
} from "../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export function ListarRenegociacaoAnaliseService(
    page: number,
    requestBody: IFiltroRenegociacaoAnalise
) {
    return Service(
        Axios.post<Array<IRenegociacoesAnalise>>(
            `/cobranca/renegociacao/listarrenegociacaoanalise?ID_PAGINA=${page}`,
            requestBody
        )
    );
}

export function GetRenegociacaoAnaliseService(
    ID_CASO_COBRANCA_NEGOCIACAO_ANALISE: number
) {
    return Service(
        Axios.get<IRenegociacaoAnalise>(
            `/cobranca/renegociacao/getrenegociacaoanalise?idCasoCobrancaRenacociacaoAnalise=${ID_CASO_COBRANCA_NEGOCIACAO_ANALISE}`
        )
    );
}

export function AtualizarRenegociacaoAnaliseService(
    ID_CASO_COBRANCA_NEGOCIACAO_ANALISE: number,
    DS_STATUS: string
) {
    return Service(
        Axios.put(`/cobranca/renegociacao/atualizarrenegociacaoanalise`, {
            DS_STATUS: DS_STATUS,
            ID_CASO_COBRANCA_NEGOCIACAO_ANALISE:
                ID_CASO_COBRANCA_NEGOCIACAO_ANALISE,
        })
    );
}
